<template>
  <button class="item-btn" type="button" v-bind:class="{ active: isActive }"  @click="toggleClass">
      {{ tit }}
  </button>
</template>
<script>
export default {
  name: 'togglebtn',
  props: ['isActive', 'tit'],
  methods: {
    toggleClass: function () {
      this.$emit('activate')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ToggleBtn.vue